import React, { FunctionComponent } from 'react'
import { Card, ButtonContainer } from '@vwfs-bronson/bronson-react'
import { Output } from '../../../Text'
import DescriptionListRender from '../../../common/components/DescriptionListRender/DescriptionListRender'
import TextsRender from '../../../common/components/TextsRender/TextsRender'
import { DealerRole } from '../../../common/types/enums'

export type AuthorizeAndGetVehicleProps = {
  originSystem: string,
  prefill: any;
  buttons?: any;
}

const AuthorizeAndGetVehicle: FunctionComponent<AuthorizeAndGetVehicleProps> = props => {
  const { originSystem, prefill, buttons } = props;

  const deliveryType = prefill?.vehicleData?.delivery?.deliveryType;

  const getDealerByRole = (role: string) => {
    return !!prefill?.dealerData?.additionalDealers
    && prefill?.dealerData?.additionalDealers?.find((dealer: any) => [role].includes(dealer.dealerRole));
  }

  const dealer = getDealerByRole(DealerRole.PICKUP);

  const data = [
    dealer?.companyName,
    `${dealer?.addresses?.[0]?.street || ''} ${dealer?.addresses?.[0]?.houseNumber || ''}`,
    `${dealer?.addresses?.[0]?.zipCode || ''} ${dealer?.addresses?.[0]?.city || ''}`
  ]


  return (
    <Card
      title={Output.resolve(`pages.signatureSuccess.${originSystem}.authorizeAndGetVehicle.title`)}
      className="u-text-left"
    >
      <TextsRender texts={Output.resolve(`pages.signatureSuccess.${originSystem}.authorizeAndGetVehicle.texts`)}/>
      <TextsRender
        texts={Output.resolve(`pages.signatureSuccess.${originSystem}.authorizeAndGetVehicle.${deliveryType}.texts`)}
      />
      <DescriptionListRender
        descriptionList={Output.resolve(`pages.signatureSuccess.${originSystem}.authorizeAndGetVehicle.${deliveryType}.descriptionList`)}
        descriptionListData={data}
      />

      {/* Buttons component */}
      {buttons
        ? (
          <ButtonContainer nav right className="u-mt">
            {buttons}
          </ButtonContainer>
        )
        : <></>
      }
    </Card>
  )
}

export default AuthorizeAndGetVehicle;
